const routesWithLabel = (routes, currentRoute, currentPath, search = '') => {
  const isPreAvaliation =
    new URLSearchParams(search).get('preAvaliation') === 'true'
  const supplierLabel = isPreAvaliation ? 'Pré-Avaliado' : 'Fornecedor'

  const defaultLabels = {
    // Dashboard
    [routes.myLgpd.dashboard]: '',
    // Data processes
    [routes.dataProcess.all]: 'Listagem',
    [routes.dataProcess.view]: 'Processo',
    [routes.dataProcess.new]: 'Processo',
    [routes.dataProcess.edit]: 'Processo',
    [routes.dataProcess.resume]: 'Processo',
    [routes.dataProcess.suggested]: 'Sugestão',
    [routes.dataProcess.audit]: 'Auditoria',
    [routes.dataProcess.suggestedChanges]: 'Alterações sugeridas ',
    [routes.dataProcess.treatment.all]: 'Tratamentos',
    [routes.dataProcess.treatment.manage]: 'Tratamento',
    // Departments
    [routes.department.all]: 'Listagem',
    [routes.department.new]: 'Departamento',
    [routes.department.edit]: 'Departamento',
    // Users
    [routes.user.all]: 'Listagem',
    [routes.user.new]: 'Usuário',
    [routes.user.edit]: 'Usuário',
    [routes.user.account]: 'Usuário',
    // Partners
    [routes.marketplace.all]: 'Listagem',
    [routes.marketplace.show]: 'Serviços',
    // Questionnaires
    [routes.questionnaire.all]: 'Listagem',
    // Incidents
    [routes.incidents.all]: 'Listagem',
    [routes.incidents.new]: 'Incidente',
    [routes.incidents.edit]: 'Incidente',
    [routes.incidents.show]: 'Incidente',
    // Profiles
    [routes.profiles.all]: 'Listagem',
    [routes.profiles.new]: 'Perfil',
    [routes.profiles.edit]: 'Perfil',
    // Fornecedores
    [routes.thirdPartyManagements.mySuppliers.all]: 'Listagem',
    [routes.thirdPartyManagements.mySuppliers.new]: supplierLabel,
    [routes.thirdPartyManagements.mySuppliers.show]: supplierLabel,
    [routes.thirdPartyManagements.mySuppliers.edit]: supplierLabel,
    [routes.thirdPartyManagements.preAvaliations]: 'Pré-Avaliação',
    [routes.thirdPartyManagements.questionnairesReceived]:
      'Questionários Recebidos',
    [routes.thirdPartyManagements.suggestions]: 'Sugestões',
    // Comitês
    [routes.committees.all]: 'Listagem',
    [routes.committees.show]: 'Comitê',
    [routes.committees.committeeUserNew]: 'Comitê',
    [routes.committees.committeeUserEdit]: 'Comitê',
    // Privacy By Design
    [routes.privacyByDesign.all]: 'Listagem',
    [routes.privacyByDesign.new]: 'Projeto',
    [routes.privacyByDesign.edit]: 'Projeto',
    [routes.privacyByDesign.show]: 'Projeto',
    // Phishing
    [routes.phishing.all]: 'Listagem',
    [routes.phishing.dashboard]: 'Listagem',
    [routes.phishing.new]: 'Nova Campanha',
    [routes.phishing.edit]: 'Campanha',
    [routes.phishing.show]: 'Campanha',
    [routes.phishing.details]: 'Detalhes da campanha',
    // Cookies
    [routes.cookies.banners]: 'Meus banners',
    [routes.cookies.settings]: 'Banner',
  }

  return { url: currentPath, label: defaultLabels[currentRoute] }
}

const formatters = { routesWithLabel }

export default formatters
